<template>
  <div id="importantLinks">
    <b-button v-b-modal.modal-1 class="editButton" size="sm"><i class="bi bi-pencil-fill icon iconButton"></i> </b-button>
    <b-modal id="modal-1" scrollable size="xl" :title="$t('DASHBOARD.EDIT_IMPORTANT_LINKS')" hide-header-close @ok="updateOrPostLinks">
      <div class="modal-links-container">
        <div v-for="(linkEntry, index) in fetchedData" :key="linkEntry.id || `new-${index}`" class="link-entry-row">
          <div class="link-title-column">
            <label class="form-label">{{ $t('DASHBOARD.LINK_TITLE') }}</label>
            <b-form-input v-model="linkEntry.key"></b-form-input>
          </div>
          <div class="link-url-column">
            <label class="form-label">{{ $t('DASHBOARD.URL') }}</label>
            <b-form-input v-model="linkEntry.value"></b-form-input>
          </div>
        </div>
      </div>
    </b-modal>
    <div class="importantLinksGrid">
      <div v-for="linkEntry in fetchedData" :key="linkEntry.id">
        <div class="cell">
          <a :href="linkEntry.value" class="linkStyle" target="_blank" rel="noopener noreferrer">{{ linkEntry.key }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mapGettersMixin from '../../../mixins/mapGettersMixin'
import { processPromisesMixin } from '../../../mixins/processPromisesMixin'
import axios from '../../../../axios'
export default {
  name: 'ImportantLinks',
  mixins: [mapGettersMixin, processPromisesMixin],
  data() {
    return {
      importantLinksURL: 'dashboard-elements/',
      defaultLinks: [
        {
          key: 'Jira Project Board',
          value: 'Insert your link here'
        },
        {
          key: 'Confluence Wiki',
          value: 'Insert your link here'
        },
        {
          key: 'Company Website',
          value: 'Insert your link here'
        },
        {
          key: 'GitHub Repository',
          value: 'Insert your link here'
        },
        {
          key: 'Additional Link 1',
          value: 'Insert your link here'
        },
        {
          key: 'Additional Link 2',
          value: 'Insert your link here'
        }
      ],
      fetchedData: [],
      isInitialized: false
    }
  },
  mounted() {
    this.fetchLinks()
  },
  methods: {
    async fetchLinks() {
      const importantLinks = await this.getRequestWithProjectIdPromise(this.importantLinksURL)

      this.fetchedData = importantLinks.data

      // Only initialize with default links if no links exist at all and we haven't initialized yet
      if (this.fetchedData.length === 0 && !this.isInitialized) {
        this.fetchedData = [...this.defaultLinks]
        this.isInitialized = true
      } else if (this.fetchedData.length > 0) {
        // Mark as initialized if we have data from the server
        this.isInitialized = true
      }
    },
    async updateOrPostLinks() {
      await this.addProjectIdToImportantLinks()

      // Validate and fix URLs before saving
      this.fetchedData = this.fetchedData.map((element) => ({
        ...element,
        value: this.validateAndFixUrl(element.value)
      }))

      // Process each link - create new ones or update existing ones
      for (const element of this.fetchedData) {
        if (element.id) {
          // Link exists in database, update it
          await axios.patch(`${this.importantLinksURL}${element.id}/`, element)
        } else {
          // Link doesn't exist in database, create it
          await axios.post(this.importantLinksURL, element)
        }
      }

      // Refresh the data from the server to get the updated IDs
      await this.fetchLinks()
    },
    async addProjectIdToImportantLinks() {
      const responseProjectId = await this.getProjectId
      const projectId = responseProjectId

      this.fetchedData = this.fetchedData.map((importantLink) => ({
        ...importantLink,
        project: projectId
      }))
    },
    validateAndFixUrl(url) {
      if (!url || url.trim() === '') {
        return url
      }

      const trimmedUrl = url.trim()

      // If URL already has a protocol (http://, https://, ftp://, etc.), return as is
      if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(trimmedUrl)) {
        return trimmedUrl
      }

      // If URL starts with //, it's a protocol-relative URL, return as is
      if (trimmedUrl.startsWith('//')) {
        return trimmedUrl
      }

      // If URL starts with / or ./, it's a relative path, return as is
      if (trimmedUrl.startsWith('/') || trimmedUrl.startsWith('./') || trimmedUrl.startsWith('../')) {
        return trimmedUrl
      }

      // If URL contains a dot and looks like a domain (not a relative path), add https://
      // Check if it looks like a domain: contains a dot, no spaces, and doesn't start with . or /
      if (trimmedUrl.includes('.') && !trimmedUrl.includes(' ') && !trimmedUrl.startsWith('.') && !trimmedUrl.startsWith('/')) {
        return `https://${trimmedUrl}`
      }

      // For other cases, return as is
      return trimmedUrl
    }
  }
}
</script>

<style>
.importantLinksGrid {
  display: grid;
  grid-template: auto auto auto / auto auto;
  row-gap: 30%;
}

.linkStyle {
  font-size: 24;
  font-weight: bold;
  color: #8b69a9;
}

.editButton {
  margin-bottom: 20px;
  margin-top: 10px;
}
.iconButton {
  font-size: 13px;
}

.modal-links-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.link-entry-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  align-items: start;
}

.link-title-column,
.link-url-column {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-weight: 600;
  margin-bottom: 5px;
  color: #8b69a9;
}
</style>
